import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateObjectState } from "../utils";
import moment from "moment";

const useGeneralStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      updateCompany: (action, param) => set({ company: updateObjectState(get().company, action, param) }),
      updateBrand: (action, param) => set({ brand: updateObjectState(get().brand, action, param) }),
      resetCompany: () => set(initialState), // Reset function
      //getter
      getMaxShopExpiry: () => {
        const company = get().company;

        // Return null if there's no shop expiry data
        if (!company?.permission?.shopsExpiry || company.permission.shopsExpiry.length === 0) {
          return null;
        }

        // Extract the expiry dates and find the maximum one using moment
        const maxExpiry = company.permission.shopsExpiry.reduce((max, shop) => {
          const expiryDate = moment(shop.expiry);
          return expiryDate.isAfter(max) ? expiryDate : max;
        }, moment(0)); // Start with the earliest possible moment

        return maxExpiry;
      },
    })),
    {
      name: "pearl-company", //name of store, must be unique
      //storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    }
  )
);

export default useGeneralStore;
